// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__hVLE0","heroMobile":"Hero_heroMobile__oqkR6","hero__textContainer":"Hero_hero__textContainer__6ISij","hero__title":"Hero_hero__title__BN9mc"};